import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreatePredioDto, FilterUsersDto, Predio, Programa, UserByDistance } from './types/types';

export class PrediosService {
  // POST /predios
  static async create(dto: CreatePredioDto): Promise<Predio> {
    const response: AxiosResponse<Predio> = await AxiosService.post('/predios', dto);
    return response.data;
  }

  // 🔐 PUT /users/:id (requiere JWT + rol admin)
  static async update(id: string, dto: CreatePredioDto): Promise<Predio | null> {
    const response: AxiosResponse<Predio> = await AxiosService.put(`/predios/${id}`, dto);
    return response.data;
  }

  // GET /predios
  static async findAll(): Promise<Predio[]> {
    const response: AxiosResponse<Predio[]> = await AxiosService.get('/predios');
    return response.data;
  }
  // GET /predios/:id
  static async findOne(id: string): Promise<Predio> {
    const response: AxiosResponse<Predio> = await AxiosService.get(`/predios/${id}`);
    return response.data;
  }

  // GET /predios/getClosestUsers
  static async getClosestUsers(id: string, turno?: string, trabajadorPredio?: Map<string,string>): Promise<UserByDistance[]> {
    console.log("getClosestUsers", trabajadorPredio)
    const filter: FilterUsersDto = {
      excludeUsers: [],
      role: ["WORKER"],
      turno: [],
      localidad: []
    }
    if(localStorage.getItem("organization")) {
        filter.organization = [localStorage.getItem("organization") || ""];
    }
    if(turno){
      filter.turno = [turno];
    }
    if(trabajadorPredio){
      filter.excludeUsers = Array.from(trabajadorPredio.entries())
      .filter(([key, value]) => value !== id)
      .map(([key]) => key);
    }
    const response: AxiosResponse<UserByDistance[]> = await AxiosService.post(`/predios/getClosestUsers`, filter, {
    params: {
      predio: id,
      quantity: 10,
    },
  });
    return response.data;
  }
  
  // DELETE /predios/:id
  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/predios/${id}`);
  }
}